// CSV download — lifted from the Symposium console's hand-rolled RSVP export
// (2026-09-03) so every list exports the same way.
//
// RFC 4180 quoting: a cell is quoted only when it needs to be (comma, quote,
// CR/LF); embedded quotes double. The file opens with a UTF-8 BOM so Excel on
// Windows reads accented names as UTF-8 instead of ANSI mojibake.

export type CsvCell = string | number | boolean | null | undefined

export function csvCell(v: CsvCell): string {
  if (v == null) return ''
  if (typeof v === 'boolean') return v ? 'yes' : 'no'
  const s = typeof v === 'number' ? String(v) : v
  return /[",\r\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s
}

export function csvText(header: readonly string[], rows: readonly (readonly CsvCell[])[]): string {
  const lines = [header.map(csvCell).join(',')]
  for (const r of rows) lines.push(r.map(csvCell).join(','))
  return lines.join('\r\n')
}

/** Build the CSV and trigger a browser download under `filename`. */
export function downloadCsv(filename: string, header: readonly string[], rows: readonly (readonly CsvCell[])[]): void {
  const blob = new Blob(['\ufeff', csvText(header, rows)], { type: 'text/csv;charset=utf-8' })
  const a = document.createElement('a')
  a.href = URL.createObjectURL(blob)
  a.download = filename
  a.click()
  URL.revokeObjectURL(a.href)
}
